<template>
  <div>
    <div>{{ print }}</div>
    <div v-if="false && !isProduction">
      {{ constraint }}
    </div>
    <v-popover>
      <div>
        <a>{{ $t("remove") }}</a>
      </div>
      <!-- This will be the content of the popover -->
      <template slot="popover">
        <div class="popover-wrapper">
          <div class="popover-title">{{ $t("remove-constraint") }}</div>
          <div class="popover-content">
            <small>
              <i>{{ print }}</i>
            </small>
            <br />{{ $t("are-you-sure-this-cannot-be-undone") }}
          </div>
          <div class="popover-actions mt-2">
            <button class="button is-small" @click="remove(input)">
              {{ $t("Button.confirm") }}
            </button>
            <br />
            <br />
            <button v-close-popover class="button is-small is-white">
              {{ $t("Button.cancel") }}
            </button>
          </div>
        </div>
      </template>
    </v-popover>
  </div>
</template>

<script>
import api from "@/api";

export default {
  components: {},
  props: ["input"],
  data() {
    return {
      constraint: {},
    };
  },
  computed: {
    print() {
      const c = this.constraint;
      let str = this.$t("cannot-play") + " ";

      if (c.max_games) {
        str += this.$t("more-than-c-max_games-games", [c.max_games]);
      }
      if (c.max_travel_home) {
        str += this.$t("more-than-c-max_travel_home-miles-from-home", [c.max_travel_home]);
      }
      if (c.max_travel_last) {
        str += this.$t("more-than-c-max_travel_last-miles-from-last-game", [c.max_travel_last]);
      }
      if (c.is_home_only) {
        str += `at a non-home venue `;
      }
      if (c.no_play_team) {
        str += this.$t("against-team-c-no_play_team_name", [c.no_play_team_name]);
      }
      // If all day, determine if specific date or weekday
      if (c.start_date && c.end_date) {
        str +=
          "between " +
          this.$moment(c.start_date).format("dddd, MMMM Do YYYY") +
          " and " +
          this.$moment(c.end_date).format("dddd, MMMM Do YYYY");
      } else if (c.start_date) {
        str += "on " + this.$moment(c.start_date).format("dddd, MMMM Do YYYY");
      } else if (c.wday != null) {
        str += `on ` + this.dayFromNumber(c.wday) + "s";
      }

      if (c.not_between_start && c.not_between_end) {
        str += " between ";
        str += this.$moment(c.not_between_start).format("hh:mm a");
        // str += this.$moment(c.not_between_start).format("LT");
        str += " and ";
        str += this.$moment(c.not_between_end).format("hh:mm a");
        // str += this.$moment(c.not_between_end).format("LT");
      }

      if (c.not_before && c.not_after) {
        str += "before ";
        // str += this.$moment(c.not_before).format("LT");
        str += this.$moment(c.not_before).format("hh:mm a");
        str += " or after ";
        // str += this.$moment(c.not_after).format("LT");
        str += this.$moment(c.not_after).format("hh:mm a");
      } else if (c.not_before) {
        str += "before ";
        str += this.$moment(c.not_before).format("hh:mm a");
        // str += this.$moment(c.not_before).format("LT");
      } else if (c.not_after) {
        str += " after ";
        str += this.$moment(c.not_after).format("hh:mm a");
        // str += this.$moment(c.not_after).format("LT");
      }

      if (c.is_home_only) {
        str += this.$t("home-only");
      }
      return str;
    },
  },
  methods: {
    remove(constraint) {
      api.removeTimeConstraint(constraint).then(response => {
        this.makeToast("info", this.$t("Toast.deleted-constraint"));
        this.$emit("refresh");
      });
    },
  },
  created() {
    this.constraint = JSON.parse(JSON.stringify(this.input));
  },
  mounted() {},
};
</script>

<style scoped lang="scss"></style>
